import Dispatcher from "./Dispatcher";
import Constants from "./Constants";

export default {
  showLoadingScreenOverlay(text) {
    Dispatcher.dispatch({
      actionType: Constants.APP_SHOW_LOADING_SCREEN_OVERLAY,
      text,
    });
  },

  hideLoadingScreenOverlay() {
    Dispatcher.dispatch({
      actionType: Constants.APP_HIDE_LOADING_SCREEN_OVERLAY,
    });
  },

  openDropdown(uniqueId) {
    Dispatcher.dispatch({
      actionType: Constants.OPEN_DROPDOWN,
      uniqueId,
    })
  },

  closeDropdown(uniqueId) {
    Dispatcher.dispatch({
      actionType: Constants.CLOSE_DROPDOWN,
      uniqueId,
    })
  },

  initCustomProduct(product, customProduct) {
    Dispatcher.dispatch({
      actionType: Constants.APP_INIT_CUSTOM_PRODUCT,
      product,
      customProduct
    });
  },

  updateCustomProduct(partialCustomProduct) {
    Dispatcher.dispatch({
      actionType: Constants.APP_UPDATE_CUSTOM_PRODUCT,
      partialCustomProduct,
    });
  },

  setProductCategory(category) {
    Dispatcher.dispatch({
      actionType: Constants.APP_SET_PRODUCT_CATEGORY,
      category,
    });
  },

  loadProductInViewer(code) {
    Dispatcher.dispatch({
      actionType: Constants.APP_LOAD_PRODUCT_IN_VIEWER,
      code,
    });
  },

  setViewerReference(reference) {
    Dispatcher.dispatch({
      actionType: Constants.APP_SET_VIEWER_REFERENCE,
      reference,
    });
  },

  updateCountry(country) {
    Dispatcher.dispatch({
      actionType: Constants.UPDATE_COUNTRY,
      country,
    })
  },

  getCountries() {
    Dispatcher.dispatch({
      actionType: Constants.GET_COUNTRIES,
    });
  },

  updateLanguage(language) {
    Dispatcher.dispatch({
      actionType: Constants.APP_CHANGE_LANGUAGE,
      language,
    });
  },
  setPersonalInfo(infos) {
    Dispatcher.dispatch({
      actionType: Constants.APP_SET_PERSONAL_INFO,
      infos,
    });
  },
  setOnlinePurchase(onlinePurchase) {
    Dispatcher.dispatch({
      actionType: Constants.APP_SET_ONLINE_PURCHASE,
      onlinePurchase,
    });
  }
};



// WEBPACK FOOTER //
// ./src/flux/AppActions.js